/**
 异常管理--平台事件监控列表
 */
import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import { message } from "antd";
import moment from "moment";
// 数据
import { EVENTSTATUS } from "@/utils/publicParam";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import RefreshGrid from "../../../utils/refreshGrid";
import {
  eventStatusChange,
  stubFaultReportedlevelData,
  getCityList,
  stubEventMonitoringNew,
  stubDetailInfoApi,
  stubGroupNameSearch,
  prefixFile,
} from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import { useAuth } from "@/utils/utils";
// import { OPERATIONS_LEVEL } from '@/utils/mapObj';

@connect((state) => state)
class EventMonitoring extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.eventMonitoring;
    this.yunwei = this.props.intl.messages.commonBase;
    this.state = {
      visible: false,
      levelOption: [],
      formConfig: null,
      typeOption: [
        {
          text: this.props.intl.messages.eventMonitoring.all, // '全部',
          value: "",
        },
      ],
      searchStubGroupId: "",
    };
    this.eventNameTip = [
      {
        name: "模块环温相差告警",
        message:
          "同枪同一时间点模块温度比环境温度差值＞10℃(模块温度≤30℃时，不够则忽略)，记为1个异常点；1笔订单中连续3个异常点记为1笔异常订单；每天异常订单超过3笔则告警(第3笔则会告警)，每天重置条件(跨天订单按结束时间算)。",
      },
      {
        name: "模块高温限流告警",
        message: "模块温度超出品牌给的标准范围值时告警",
      },
      {
        name: "模块温度不均衡告警",
        message:
          "同桩对比同一时间运行中模块间温度差值，差值大于5℃告警(模块温度≤30℃时，不够则忽略)。",
      },
      {
        name: "模块电流不均衡告警",
        message:
          "同枪同一时间点最大输出电流模块与其他所有工作模块比较，差值＞2A记为1个异常点。剔除订单最开始和最后各2个采样点，若单笔订单中出现连续5个采样点(模块温度达到达到模块高温限流阈值的采样点不计算)异常则该笔订单记为异常订单，每天异常订单超过3笔则告警(第3笔则会告警)。",
      },
      {
        name: "模块配置异常告警",
        message:
          "实时监控产生有效订单的设备(时长超过3分钟为有效订单，若无效订单则默认为无订单。双枪以上的设备会同时产生多个订单，需要合并订单进行判断)，每台设备每日只监控一次(无订单设备无需监控，充电中订单需要判断是否超过3分钟，若无超过该订单在第二天时需要重新检测)。判断订单上报工作模块数量最大值是否与型号表一致，若上报工作模块数量˂型号表则判断为异常并告警。",
      },

      {
        name: "充电桩频繁掉线告警",
        message: "设备24小时内出现X次离线（X在监控事件配置），则判断为异常并告警。",
      },

      {
        name: "充电桩长时掉线告警",
        message: "单次离线时长超过配置的时间，则判断为异常并告警。",
      },

      {
        name: "异常扣费订单告警",
        message:
          "每小时去检测已完成的充电订单，如果有订单金额为0且度数大于1的或者订单金额超出配置的金额则判断为异常并告警。",
      },

      {
        name: "连续异常订单告警",
        message:
          "每小时去检测异常扣费订单的告警记录，单桩连续出现X次异常扣费或者单个账户出现X次异常扣费则判断为异常并告警。",
      },
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  /**
   * 页面加载前执行，初始化form表单，表格
   */
  componentWillMount() {
    this.getLevel();
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  /**
   * 页面加载后执行方法，初始化表格数据
   */
  componentDidMount() {
    let param = {
      date: `${moment(new Date()).subtract(0, "d").format("YYYY.MM.DD")},${moment(new Date())
        .subtract(0, "d")
        .format("YYYY.MM.DD")}`,
    };
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      const date = window.LayoutTab.tabParam.date;
      param = {
        ...param,
        ...window.LayoutTab.tabParam,
        date: `${date[0].format("YYYY.MM.DD")},${date[1].format("YYYY.MM.DD")}`,
      };
    }
    this.fetchApi(param);
  }

  // 获取故障等级
  getLevel() {
    fetchHandler(stubFaultReportedlevelData, {
      type: "2",
    }).then((res) => {
      // console.log(res);
      const list = res.data.map((item) => {
        const foo = {
          text: item.name,
          value: item.id,
        };
        return foo;
      });
      const first = {
        text: this.internationalization.all, // '全部',
        value: "",
      };
      list.unshift(first);
      this.setState(
        {
          levelOption: list,
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
      this.init();
    });
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`; // + second + "秒";
    } else if (hour > 0) {
      return `${hour}时${minute}分`; // + second + "秒";
    } else if (minute > 0) {
      return `${minute}分`; // + second + "秒";
    } else {
      return `${second}秒`;
    }
  }

  /**
   * 对告警状态进行转换
   */
  switchStats = (value) => {
    let str = "";
    switch (value) {
      case 0:
        str = "待处理";
        break;
      case 1:
        str = "处理中";
        break;
      case 2:
        str = "已处理";
        break;
      case 3:
        str = "已关闭";
        break;
      default:
        str = "--";
        break;
    }
    return str;
  };

  exportOrderStuGroup = (paramString) => {
    const excelUrl = `${prefixFile}/exportStubEventMonitoringList.do`;
    //   cityId:record.city,
    //   stubGroupId:record.key,
    //   startTime:moment(new Date()).subtract(29, "d").format("YYYY-MM-DD"),
    //   endTime:moment(new Date()).format("YYYY-MM-DD")
    // };
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  /**
   * 初始化表格
   */
  init() {
    this.setState({
      tableConfig: {
        tableKey: "eventMonitoringListTable",
        tableColumns: [
          {
            name: this.internationalization.title7, // '事件名称',
            message: (
              <div style={{ width: 500 }}>
                {this.eventNameTip.map((value) => (
                  <p>
                    <b>{value.name}</b>：{value.message}
                  </p>
                ))}
              </div>
            ),
            key: "eventName",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.title10, // '设备编号',
            key: "stubId",
            colType: "textCol",
            align: "left",
            render: (value) => {},

            render: (value, row) => {
              if (value === "null") {
                return "--";
              } else if (value === "") {
                return "--";
              } else {
                return (
                  <div
                    onClick={(e) =>
                      this.openTab(
                        {
                          // keyId: `stub_${record.key}`,
                          // StubName: record.name,
                          stubId: row.stubId,
                        },
                        {
                          key: "0102",
                          titleText: "设备快速查询", // '设备快速查询',
                        },
                      )
                    }>
                    <a>{row.stubId}</a>
                  </div>
                );
              }
            },
          },
          {
            name: "设备类型", // '设备类型'
            key: "stubType",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return "交流电"; // '交流电';
                case 1:
                  return "直流电"; // '直流电';
                case 2:
                  return "交直流"; // '交直流';
                default:
                  return "未知"; // '未知'
              }
            },
          },
          {
            name: this.internationalization.title11, // '运维等级',
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    padding: "0 22px",
                  }}>
                  <div className="tip-lv">
                    <span className="first" style={{ background: row.color }}></span>
                    <span className="last" style={{ background: row.color }}></span>
                  </div>
                  <span>{row.levelName}</span>
                </div>
              );
            },
          },
          {
            name: "告警信息",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return (
                <div style={{ width: "350px" }}>
                  <span
                    style={{
                      "word-wrap": "break-word",
                      "word-break": "break-all",
                      "white-space": "pre-wrap",
                    }}>
                    {row.msg}
                  </span>
                </div>
              );
            },
          },
          {
            name: this.internationalization.title12, // '次数',
            key: "eventCnt",
            align: "center",
            colType: "numCol",
          },
          {
            name: `最新${this.internationalization.title13}`, // '上报时间',
            key: "lastReportTime",
            colType: "textCol",
            align: "left",
          },
          {
            name: "告警周期", // '告警周期',
            key: "eventCycle",
            align: "left",
            colType: "textCol",
            render: (value) => this.handleSecord(value),
          },
          // {
          //   name: "状态",
          //   key: "eventStatus",
          //   colType: "textCol",
          //   align: "left",
          //   render: (value) => {
          //     const str = this.switchStats(value);
          //     return str;
          //   },
          // },
          {
            name: "工单号", // '工单号',
            key: "workOrderId",
            align: "left",
            colType: "textCol",
            render: (value) => value || "--",
          },
          // {
          //   name: "负责人", // '负责人',
          //   key: "workOrderManager",
          //   align: "left",
          //   colType: "textCol",
          //   render: (value) => (value || "--"),
          // },
          {
            name: this.internationalization.title14, // '电站名称',
            key: "stubGroupName",
            colType: "tipCol",
            align: "left",
          },
          {
            name: this.internationalization.title15, // '地区',
            key: "cityName",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.title17, // '设备型号',
            key: "modelNo",
            colType: "textCol",
            align: "left",
            render: (value) => {
              if (value === "null") {
                return "--";
              } else {
                return value;
              }
            },
          },
          {
            name: "运营类型", // '运营类型',
            key: "operationMode",
            colType: "textCol",
            align: "left",
            width: 200,
            render: (value) => {
              if (value.toString() === "1") {
                return "直营";
              } else if (value.toString() === "0") {
                return "非直营";
              } else {
                return "--";
              }
            },
          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            width: 100,
            colType: "action",
            actionMap: [
              useAuth("040203")
                ? {
                    type: "href",
                    actionName: this.internationalization.btn1, // '模块信息',
                    handler: (record) => {
                      this.openTab(
                        {
                          keyId: "moduleInfo",
                          stubId: record.stubId,
                          createTime: record.createTime,
                          subjectSerial: record.subjectSerial,
                          eventName: record.eventName,
                        },
                        {
                          key: "moduleInfo",
                          titleText: this.internationalization.wz2, // '模块信息',
                        },
                      );
                    },
                  }
                : "",
              useAuth("040204")
                ? {
                    type: "confirm",
                    actionName: "更改状态", // '更改状态',record.eventStatus 、、record.eventStatus == 3
                    popText: (record) => {
                      return `确定更改状态为${this.switchStats(record.eventStatus + 1)}吗？`;
                    },
                    render: (record) => (record.eventStatus === 3 ? null : "更改状态"),
                    handler: (record) => {
                      fetchHandler(eventStatusChange, {
                        stubEventId: record.stubEventId,
                        eventStatus: record.eventStatus + 1,
                      }).then((res) => {
                        if (res && (res.code === "success" || res.code === "ok")) {
                          message.success("状态更改成功");
                          // 刷新列表
                          RefreshGrid(this.context.store, "eventMonitoringListTable");
                        }
                      });
                    },
                  }
                : "",
              useAuth("040205")
                ? {
                    type: "href",
                    actionName: "详情",
                    handler: (record) => {
                      if (record.eventCfgId === "5") {
                        // 事件为 模块配置异常跳转至订单信息页面
                        record.searchTime = record.lastReportTime;
                        this.openTab(
                          {
                            keyId: "0501",
                            stubInfoData: record,
                          },
                          {
                            key: "0501",
                            titleText: "订单信息",
                          },
                        );
                      } else {
                        // if(!record.subjectSerial) {
                        //     message.error('缺少主体编号');
                        //     return
                        // }
                        // 其他事件跳转至告警详情页

                        this.openTab(
                          {
                            keyId: "monitoringDetail",
                            stubId: record.stubId,
                            modifyTime:
                              record.eventStatus === 3
                                ? record.lastReportTime
                                : moment().format("YYYY.MM.DD HH:mm:ss"),
                            createTime: record.createTime,
                            eventCfgId: record.eventCfgId,
                          },
                          {
                            key: "monitoringDetail",
                            titleText: "模块事件监控详情",
                          },
                        );
                      }
                    },
                  }
                : "",
              useAuth("040206")
                ? {
                    type: "href",
                    actionName: "一键报修", // '',
                    handler: (res) => {
                      this.goBao(res);
                    },
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pageCount: 10,
        },
        dataApi: stubEventMonitoringNew,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  /**
   * 查询form初始化
   */
  initFormConfig = () => {
    const statusOption = EVENTSTATUS;

    const formConfig = {
      childItems: [
        {
          type: "select",
          options: [
            {
              text: "全部", // '全部',
              value: "",
            },
            {
              text: "模块环温相差告警", // '交流电',
              value: "模块环温相差告警",
            },
            {
              text: "模块高温限流告警", // '直流电',
              value: "模块高温限流告警",
            },
            {
              text: "模块温度不均衡告警", // '交直流',
              value: "模块温度不均衡告警",
            },
            {
              text: "模块电流不均衡告警", // '交直流',
              value: "模块电流不均衡告警",
            },
            {
              text: "充电桩频繁掉线告警", // '充电桩频繁掉线告警',
              value: "充电桩频繁掉线告警",
            },
            {
              text: "充电桩长时掉线告警", // '充电桩长时掉线告警',
              value: "充电桩长时掉线告警",
            },
            {
              text: "连续异常订单告警", // '交直流',
              value: "连续异常订单告警",
            },
            {
              text: "异常扣费订单告警", // '交直流',
              value: "异常扣费订单告警",
            },
            {
              text: "模块配置异常告警", // '交直流',
              value: "模块配置异常告警",
            },
          ],
          placeholder: "请选择", // '请选择设备类型',
          param: {
            name: "eventName",
            type: "string",
          },
          labelName: this.internationalization.title7, // '设备类型',
          required: false,
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.eventName,
        },
        {
          type: "autoWatchFetch",
          placeholder: "请输入电站名称", // '请输入电站名称',
          labelName: "电站名称", // '电站名称',
          param: {
            name: "stubGroupId",
            type: "string",
          },
          optionInfo: {
            optionKey: "id",
            optionText: "name",
          },
          searchParam: {},
          searchListName: "eventStubGroupList",
          searchKey: "stubGroupListByName",
          required: false,
          onSelect: (value, option) => {
            this.setState({
              searchStubGroupId: option.key,
            });
          },
          onChange: () => {
            if (this.state.searchStubGroupId) {
              this.setState({
                searchStubGroupId: "",
              });
            }
          },
          sourceApi: stubGroupNameSearch,
        },
        {
          type: "input",
          placeholder: "请输入设备编号",
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: "设备编号:",
          required: false,
        },
        {
          type: "select",
          options: [
            {
              text: "全部", // '全部',
              value: "",
            },
            {
              text: "交流电", // '交流电',
              value: "0",
            },
            {
              text: "直流电", // '直流电',
              value: "1",
            },
            {
              text: "交直流", // '交直流',
              value: "2",
            },
          ],
          placeholder: "请选择", // '请选择设备类型',
          param: {
            name: "stubType",
            type: "string",
          },
          labelName: "设备类型", // '设备类型',
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入负责人",
          param: {
            name: "workOrderManager", // 字段名称待定
            type: "string",
          },
          labelName: "负责人:",
          required: false,
        },
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.internationalization.placeholder3, // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: this.internationalization.title2, // '地区',
          className: "allshow",
          sourceApi: getCityList,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择设备状态',
          labelName: "运营类型", // '设备状态',
          param: {
            name: "operationMode",
            type: "string",
          },
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "非直营",
              value: "0",
            },
            {
              text: "直营",
              value: "1",
            },
          ],
          required: false,
        },
        {
          type: "select",
          options: this.state.levelOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "levenId",
            type: "string",
          },
          labelName: this.internationalization.title3, // '运维等级',
          required: !1,
        },
        {
          type: "select",
          allowClear: true,
          options: statusOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "eventStatus",
            type: "string",
          },
          labelName: "状态",
          required: !1,
        },
        {
          type: "date",
          width: "200px",
          allowClear: false,
          dateType: "rangeDate",
          placeholder: ["年/月/日", "年/月/日"],
          param: {
            name: "date",
            type: "array",
          },
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.date
              ? window.LayoutTab.tabParam.date
              : [moment(new Date()).subtract(0, "d"), moment(new Date()).subtract(0, "d")],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 31, // 可选最大天数
          },
          labelName: this.internationalization.title5, // '日期:',
          required: true,
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              labelName: "告警次数",
              type: "input",
              placeholder: "最小值",
              inputType: "number",
              checkType: "0",
              width: "95px",
              param: {
                name: "minCnt",
                type: "string",
              },
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "positiveInt", // 校验名称
                min_val: 1, // 可输入最小值
                max_val: 9999, // 可输入最大值
              },
            },
            {
              type: "input",
              placeholder: "最大值",
              inputType: "number",
              checkType: "0",
              width: "95px",
              required: false,
              param: {
                name: "maxCnt",
                type: "string",
              },
              validator: {
                // 自定义校验对象
                vtype: "positiveInt", // 校验名称
                min_val: 1, // 可输入最小值
                max_val: 9999, // 可输入最大值
              },
            },
          ],
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("040201")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.title6, // '查询'
                }
              : "",
            useAuth("040202")
              ? {
                  btnType: "button",
                  text: "导出", // '导出',
                  handler: (e, param) => {
                    const newParam = param;

                    newParam.token = window.sessionStorage.getItem("token");
                    newParam.companyId = window.sessionStorage.getItem("companyId");
                    newParam.flag = 1;
                    let paramString = "";
                    const date = newParam.date.split(",");
                    newParam.startTime = date[0];
                    newParam.endTime = date[1];
                    delete newParam.date;
                    Object.keys(newParam).forEach((key) => {
                      const paraminfo = newParam[key] ? newParam[key] : "";
                      paramString += `${key}=${paraminfo}&`;
                    });
                    this.exportOrderStuGroup(paramString);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: 1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {
        operationProperty: "3",
      },
      tableKey: "eventMonitoringListTable",
      tablePage: "事件监控",
    };
    return formConfig;
  };

  /**
   *
   * 更新表格数据方法
   */
  fetchApi = (param) => {
    const newParam = param;

    const data = [param.date.split(",")[0], param.date.split(",")[1]];
    console.log(param);
    // 城市id格式化
    newParam.cityId =
      newParam.cityId === undefined
        ? ""
        : newParam.cityId
            .toString()
            .slice(
              newParam.cityId.toString().lastIndexOf(",") + 1,
              newParam.cityId.toString().length,
            );

    // 起始时间
    newParam.startTime = `${moment(data[0]).format("YYYY.MM.DD")} 00:00:00`;
    newParam.endTime = `${moment(data[1]).format("YYYY.MM.DD")} 23:59:59`;
    // 设置电站名称
    if (newParam.stubGroupId) {
      if (this.state.searchStubGroupId) {
        newParam.stubGroupId = this.state.searchStubGroupId;
      }
    } else {
      newParam.stubGroupId = "";
    }
    delete newParam.date;

    newParam.operationProperty = "3";

    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "eventMonitoringListTable", newParam);
    }
  };

  /**
   * 新开页方法
   */
  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  goBao(res) {
    fetchHandler(stubDetailInfoApi, {
      stubId: res.stubId,
    }).then((result) => {
      window.sessionStorage.removeItem("serviceProvider");
      window.sessionStorage.removeItem("proXType");
      window.sessionStorage.removeItem("isThird");
      window.sessionStorage.removeItem("deee");
      window.sessionStorage.removeItem("hideModal");

      this.openTab(
        {
          // keyId: `stub_${record.key}`,
          // StubName: record.name,

          initSetting: {
            ticketType: 89,
            stubId: res.stubId,
            msg: res.msg,
            stuInfo: result,
            isEventMonitor: true,
          },
        },
        {
          key: "9103create",
          titleText: "创建工单", // '设备快速查询',
        },
      );
    });
  }
  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel sjjkTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(EventMonitoring);



// WEBPACK FOOTER //
// ./src/AntD/pages/exceptionManagement/eventMonitoring/eventMonitoring.js